import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ConfirmationService, Message, TreeNode } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';
import { PermissaoService } from 'src/app/admihair/service/permissao.service';
import { Permissao } from 'src/app/admihair/api/dto/permissao';
import { CategoriaPermissao } from 'src/app/admihair/api/dto/categoria-permissao';
import { UsuarioPermissaoEmpresaService } from 'src/app/admihair/service/usuario-permissao-empresa.service';
import { CategoriaPermissaoService } from 'src/app/admihair/service/categoria-permissao.service';
import { CategoriaPermissaoAgrupada } from 'src/app/admihair/api/dto/categoria-permissao-agrupada';
import { TreeTable } from 'primeng/treetable';
import { HttpStatusCode } from '@angular/common/http';
import { Administradora } from 'src/app/admihair/api/dto/administradora';
import { UsuarioPermissaoAdministradoraRequest } from 'src/app/admihair/api/dto/usuario-permissao-administradora-request';
import { UsuarioPermissaoAdministradoraService } from 'src/app/admihair/service/usuario-permissao-administradora.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';


@Component({
  selector: 'app-usuario-franquia-inserir',
  templateUrl: './usuario-franquia-inserir.component.html',
  styleUrls: ['./usuario-franquia-inserir.component.scss']
})
export class UsuarioFranquiaInserirComponent extends AdmihairBaseComponent implements OnInit {


  @ViewChild('filter') filter!: ElementRef;
  loading: boolean = false;
  administradoraId?: number;

  usuarioSelecionado?: Usuario;
  emailConsulta?: string;
  cpfConsulta?: string;
  tiposBusca: string[] = ['CPF', 'E-mail'];
  buscaSelecionada: string = 'E-mail';
  progressoRequisicao: boolean = false;
  
  mensagemNovoUsuario: Message[] = [];
  exibirMensagemNovoUsuario: boolean = false;
  novoUsuario: Usuario = {};
  emailValido: boolean = true;
  progressoNovoUsuario: boolean = false;

  exibirDialogPermissao: boolean = false;
  exibirSpinnerDialog: boolean = false;
  exibirDialogNovoUsuario: boolean = false;

  colunasTreeTable: any[] = [];
  categoriasTreeTable: TreeNode[] = [];
  categoriasTreeTableSelecionada: TreeNode[] = [];

  colunasTreeTableAdicionadas: any[] = [];
  categoriasTreeTableAdicionadas: TreeNode[] = [];
  categoriasTreeTableAdicionadasSelecionada: TreeNode[] = [];

  constructor(private usuarioService: UsuarioService,
    private usuarioPermissaoAdministradoraService: UsuarioPermissaoAdministradoraService,
    private categoriaPermissaoService: CategoriaPermissaoService,
    private confirmationService: ConfirmationService,
    erroService: ErroService,
    utilStorageService: UtilStorageService
  ) { super(erroService, utilStorageService) }

  ngOnInit(): void {
    this.inicializarColunas();
    this.administradoraId = this.getAdministradora().id;
  }

  inicializarColunas(){
    this.colunasTreeTable = [
      { field: 'descricao', header: 'Permissão' }
    ];
    this.colunasTreeTableAdicionadas = [
      { field: 'descricao', header: 'Permissão' }
    ];
  }


  
  consultarUsuario() {
    const tipo = 'FRANQUIA'
    
    if (this.buscaSelecionada == 'E-mail') {
      this.usuarioService.buscarPorTipoEEmailEFranquia(tipo, this.emailConsulta, this.administradoraId).subscribe({
        next: (data: Usuario) => {
          this.usuarioSelecionado = data;
          this.messagemVisivel = false;
        },
        error: (err: any) => {
          if(err.status === HttpStatusCode.NotFound) {
            this.exibirCadastrarUsuario(err);
          } else {
            this.usuarioSelecionado = undefined;
            this.exibirMensagemErro(err);
          }
        }
      });
    } else if (this.buscaSelecionada == 'CPF') {
      this.usuarioService.buscarPorTipoECpfEFranquia(tipo, this.cpfConsulta, this.administradoraId).subscribe({
        next: (data: Usuario) => {
          this.usuarioSelecionado = data;
          this.messagemVisivel = false;
        },
        error: (err: any) => {
          if(err.status === HttpStatusCode.NotFound) {
            this.exibirCadastrarUsuario(err);
          } else {
            this.usuarioSelecionado = undefined;
            this.exibirMensagemErro(err);
          }
        }
      });
    }
      
  } 

  abrirDialogPermissao() {
    this.exibirDialogPermissao = true;
    this.listarCategoriasPermissoes();
  }


  listarCategoriasPermissoes() {
    this.exibirSpinnerDialog = true;
    this.categoriaPermissaoService.listarTodosPorFranquia().subscribe({
      next: (data: CategoriaPermissaoAgrupada[]) => {
        this.exibirSpinnerDialog = false;
        this.categoriasTreeTable = this.converterParaTreeNode(data)
      },
      error: (err: any) =>{
        this.exibirSpinnerDialog = false;
        this.exibirMensagemErro(err);
      } 
    });
  }

  converterParaTreeNode(categorias: CategoriaPermissaoAgrupada[]): TreeNode[] {
    return categorias.map(categoria => ({
      data: categoria,
      children: categoria.permissoes ? categoria.permissoes.map(permissao => ({
        data: permissao,
        leaf: true
      })) : []
    }));
  }

  adicionarPermissao() {
    let permissoes: Permissao[] = [];
    for (const item of this.categoriasTreeTableSelecionada) {
      if (!item.children) {
        permissoes.push(item.data);
      }
    }

    let categoriasPermissoes: CategoriaPermissao[] = [];
    for (const perm of permissoes) {
      if (perm.categoriaPermissao) {
        if (!categoriasPermissoes.some(categoria => categoria.id === perm.categoriaPermissao?.id)) {
          categoriasPermissoes.push(perm.categoriaPermissao);
        }
      }
    }

    let categoriasPermissoesAgrupadas: CategoriaPermissaoAgrupada[] = [];

    for (const item of categoriasPermissoes) {
      let permissoesList: Permissao[] = [];
      for (const itemPerm of permissoes) {
        if (itemPerm.categoriaPermissao?.id === item.id) {
          permissoesList.push(itemPerm);
        }
      }
      let categoriaPermissaoAgrupadaItem: CategoriaPermissaoAgrupada = {
        id: item.id,
        descricao: item.descricao,
        permissoes: permissoesList
      }
      categoriasPermissoesAgrupadas.push(categoriaPermissaoAgrupadaItem);
    }

    this.categoriasTreeTableAdicionadas = this.converterParaTreeNode(categoriasPermissoesAgrupadas);
    this.exibirDialogPermissao = false;
  }

  SalvarPermissoes(){
    this.progressoRequisicao = true;

    let permissoes: Permissao[] = [];
    let filhosTree: TreeNode[] = [];
    for(const item of this.categoriasTreeTableAdicionadas){
      if(item.children){
        for(const filho of item.children){
          filhosTree.push(filho);
          permissoes.push(filho.data);
        }
      }
    }

    const listaPermissoesId: number[] = [];
    for(const item of permissoes){
      if(item.id){
        listaPermissoesId.push(item.id);
      }
    }

    const usuarioPerm: UsuarioPermissaoAdministradoraRequest = {
      administradoraId: this.administradoraId,
      usuarioId: this.usuarioSelecionado?.id,
      permissoesId: listaPermissoesId
    }

    this.usuarioPermissaoAdministradoraService.salvarPermissoes(usuarioPerm).subscribe({
      next: () => {
        this.progressoRequisicao = false;
        this.exibirMensagemSucesso();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.exibirMensagemErro(err);
      }
    })

  }

  exibirCadastrarUsuario(err: any){
    this.confirmationService.confirm({
      message: 'Deseja cadastrar o usuário?',
      header: `${this.buscaSelecionada} sem cadastro`,
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.exibirDialogNovoUsuario = true;
        this.novoUsuario.cpf = this.cpfConsulta;
        this.novoUsuario.email = this.emailConsulta;
      },
      reject: () => {
        this.usuarioSelecionado = undefined;
        this.exibirMensagemErro(err);
      }
    });
  }


  cadastrarUsuario(){
    if(this.novoUsuario){
      this.progressoNovoUsuario = true;
      this.novoUsuario.apelido = this.formatarApelido(this.novoUsuario.nome);
      this.novoUsuario.senha = '';
      this.novoUsuario.login = this.novoUsuario.email;
      this.novoUsuario.tipo = 'FRANQUIA';
      this.novoUsuario.situacaoConfirmacaoConta = 'AGUARDANDO_CONFIRMACAO';
      this.novoUsuario.primeiroAcesso = true;
      this.usuarioService.salvar(this.novoUsuario).subscribe({
        next: (data: Usuario) => {
          this.progressoNovoUsuario = false;
          this.usuarioSelecionado = data;
          this.exibirDialogNovoUsuario = false;
          this.messages =  [{ severity: 'success', summary: 'Sucesso', detail: 'Usuário salvo com sucesso' }];
          this.messagemVisivel = true;
        },
        error: (err: any) => {
          this.progressoNovoUsuario = false;
          this.exibirMensagemErro(err);
        }
      });
    }
    
  }

  verificarEmailUsuario(temErro?: boolean){
    if(!temErro && this.novoUsuario?.email){
      this.usuarioService.buscarPorEmail(this.novoUsuario.email).subscribe({
        next: (data: Usuario) => {
          this.emailValido = false;
        },
        error: (err: any) => {
          if(err.status === HttpStatusCode.NotFound){
            console.log(err)
            this.emailValido = true;
          }
          console.log(err)
        }
      });
    }
    
  }

  formatarApelido(nome?: string): string {
    return nome !== undefined ? nome.split(' ')[0] : '';
  }

  limparUsuario() {
    this.usuarioSelecionado = undefined;
    this.emailConsulta = '';
    this.cpfConsulta = '';
    this.messagemVisivel = false;
  }

  buscar(table: TreeTable, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

   limpar(table: TreeTable) {
    table.filterGlobal('', 'contains');
    this.filter.nativeElement.value = '';
  }


}
